{
  "es": {
    "space": {
      "actions": {
        "assignOtherUnit": "Reasignar a unidad",
        "assignSpace": "Asignar anejo",
        "assignUnit": "Asignar a una unidad",
        "cancel": "Deshacer",
        "closeEdit": "Cerrar edición",
        "create_space": "Crear anejo",
        "delete": "Eliminar",
        "edit": "Editar",
        "goToSpaces": "Crear nuevos anejos",
        "new": "Anejo",
        "save": "Guardar",
        "unassign": "Desasignar unidad",
        "unassignSpaces": "Desasignar anejos"
      },
      "attributes": {
        "category": "Tipo",
        "description": "Descripción",
        "level": "Nivel",
        "name": "Nombre",
        "price_value": "Valor total de venta",
        "price_value_construction": "Valor de construcción",
        "price_value_land": "Valor del suelo",
        "quotity": "Parte del importe de transmisión",
        "status": "Estado",
        "unit": "Unidad"
      },
      "category": {
        "bicyclestorage": "Trastero para bicicletas",
        "cellar": "Sótano",
        "garagebox": "Plaza de garaje",
        "other": "Otro",
        "outdoor_space": "Espacio exterior",
        "parkinglot": "Plaza de aparcamiento",
        "storage": "Trastero",
        "winecellar": "Bodega de vino"
      },
      "labels": {
        "allSpacesAssigned": "Todos los anejos se han asignado a una unidad.",
        "assignedSpaces": "Anejos asignados",
        "internal": "Interno",
        "noCategory": "Sin tipo definido",
        "noSpaceAssigned": "Sin anejos asignados",
        "noSpaces": "Todavía no se han creado anejos",
        "notAssignedToUnit": "Sin unidad asignada",
        "onlyAvailableSpacesShown": "Solo se muestran los anejos disponibles",
        "selectToUnassign": "Selecciona para desasignar",
        "space": "Anejo",
        "spaces": "Anejos",
        "spacesProject": "Anejos del proyecto {project}",
        "unassignedSpaces": "Anejos sin asignar"
      },
      "validation": {
        "needCategory": "Se requiere un tipo",
        "needName": "El nombre es obligatorio",
        "needNumber": "Debe ser un número (p. ej. 95)",
        "selectSpace": "Selecciona al menos 1 anejo"
      }
    }
  }
}
